import { message } from "antd";
import { getRequestVerificateToken, postRequestLogin } from "../../../config";
import { loginState, logoutUser, setLoading, verificateToken } from "./auth";
import { AuthRoot, InmersysRoot } from "../../../router/type_router";
import { rolTypeActive } from "../../../helpers/rolType";
import { setErrorServer } from "../ui/ui";

export const existToken = (navigate, privateRouter = false) => {
    return async (dispatch) => {
        try {
            const remember = localStorage.getItem("remember");
            if (remember === "true") {
                const response = await getRequestVerificateToken();
                const { status, payload } = response;
                if (status > 0) {
                    dispatch(verificateToken({ authentication: false }));
                    navigate(AuthRoot.root);
                } else {
                    dispatch(saveDataAuthentication(payload));
                    if (!privateRouter) {
                        navigate(InmersysRoot.root);
                    }
                }
            } else {
                dispatch(verificateToken({ authentication: false }));
                navigate(AuthRoot.root);
            }
            dispatch(setErrorServer({ value: false }));
        } catch (error) {
            dispatch(logout());
            dispatch(setErrorServer({ value: true }));
            message.error("Error servidor");
        }
    };
};

export const login = (navigate, form) => {
    return async (dispatch) => {
        const { email, password } = form;
        dispatch(setLoading(true));
        const { status, msg, payload } = await postRequestLogin({ email, password });

        if (status === 500 || !payload || payload === null) {
            message.error(msg);
        } else if (status > 0) {
            message.warning(msg);
            localStorage.removeItem('token');
        } else if (!payload.token) {
            localStorage.removeItem('token');
            message.warning(`Error de autenticación, vuelve a iniciar sesión`);
        } else {
            localStorage.setItem("remember", true);
            localStorage.setItem("token", payload.token);
            dispatch(saveDataAuthentication(payload));
            navigate(InmersysRoot.root);
        }
        dispatch(setLoading(false));
    };
};

export const saveDataAuthentication = (
    payload = {
        rolType: 1,
        user: {
            name: "fake",
            email: "fake@inmersys.com",
        },
    }
) => {

    return async (dispatch) => {
        const [isAdmin, isSuperAdmin, isViewer, isUser] = rolTypeActive(payload.rolType);
        dispatch(
            loginState({
                name: payload.user.name,
                email: payload.user.email,
                isAdmin: isAdmin,
                isSuperAdmin: isSuperAdmin,
                isViewer: isViewer,
                isUser: isUser,
            })
        );
    };
};

export const logout = (navigate) => {
    return async (dispatch) => {
        try {
            dispatch(logoutUser());
            localStorage.clear();
            navigate(AuthRoot.root);
        } catch (error) {
            const info = error.response.data;
            if (info.status === 500) {
                message.error("Error del servidor");
            }
        }
    };
};
